import React, {Component} from 'react';
import {Grid, Paper, Typography} from 'material-ui';
import firebase from 'firebase';
import _ from 'lodash';
import moment from 'moment';
import * as d3 from 'd3';
import nv from 'nvd3';
import HeaderBar from './components/HeaderBar';

const chartPadding = 5;

class StatusPage extends Component {
  state = {
    todayGames: [],
    weeklyGames: [],
    monthlyGames: [],
  };
  constructor() {
    super();
    this.db = firebase.firestore();
  }

  componentDidMount() {
    this.todayGames();
    this.weeklyGames();
    this.monthlyGames();
  }

  todayGames = () => {
    const midNight = new Date();
    midNight.setHours(0, 0, 0, 0);
    this.getGamesbyTime(midNight.getTime()).then(data => {
      this.setState({todayGames: data});
    });
  };

  weeklyGames = () => {
    const week = new Date();
    week.setDate(week.getDate() - 7);
    week.setHours(0, 0, 0, 0);
    this.getGamesbyTime(week.getTime()).then(data => {
      this.setState({weeklyGames: data});
    });
  };

  monthlyGames = () => {
    const month = new Date();
    month.setMonth(month.getMonth() - 1);
    month.setHours(0, 0, 0, 0);
    this.getGamesbyTime(month.getTime()).then(data => {
      this.setState({monthlyGames: data});
    });
  };

  getGamesbyTime = time => {
    return this.db
      .collection('games')
      .where('date', '>', time)
      .get()
      .then(snapshot => {
        const allGames = [];
        snapshot.forEach(gameSnapshot => {
          allGames.push(gameSnapshot.data());
        });
        return allGames;
      });
  };

  weeklyChart = () => {
    const datum = this.generateMonthlyData();
    if (datum[0].values.length === 0) {
      return;
    }
    const labels = datum[0].values.map(data => data.label);
    nv.addGraph(() => {
      const chart = nv.models
        .lineChart()
        .x(function(d, i) {
          return i;
        })
        .y(function(d) {
          return d.value;
        })
        .margin({"left": 20, "right": 20})
        .showXAxis(true)
        .showYAxis(true)
        .showLegend(true);
      const maxY = _.orderBy(datum[0].values, 'value', 'desc')[0];
      chart.forceY([0, maxY.value + chartPadding]);
      chart.xAxis.tickFormat(d => {
        return labels[d];
      });
      d3
        .select(this.refs['weeklyChart'])
        .datum(datum)
        .call(chart);
      nv.utils.windowResize(() => chart.update());
    });
  };

  gameModeChart = () => {
    const datum = this.generateMonthlyGameModeData();
    if (datum[0].values.length === 0) {
      return;
    }
    const labels = datum[0].values.map(data => data.label);
    nv.addGraph(() => {
      const chart = nv.models
        .lineChart()
        .x(function(d, i) {
          return i;
        })
        .y(function(d) {
          return d.value;
        })
        .margin({"left": 20, "right": 20})
        .showXAxis(true)
        .showYAxis(true)
        .showLegend(true);
      const maxY = _.orderBy(datum[0].values, 'value', 'desc')[0];
      chart.forceY([0, maxY.value + chartPadding]);
      chart.xAxis.tickFormat(d => {
        return labels[d];
      });
      d3
        .select(this.refs['gameModeChart'])
        .datum(datum)
        .call(chart);
      nv.utils.windowResize(() => chart.update());
    });
  };

  generateMonthlyGameModeData = () => {
    const daily = this.state.monthlyGames.reduce(
      (prev, current) => {
        const date = moment(current.date);
        const dateLabel = date.format('D/M');
        const {mode} = current;
        //  Assign default value
        if (!prev.normal[dateLabel]) {
          prev.normal[dateLabel] = 0;
        }
        if (!prev.chaos[dateLabel]) {
          prev.chaos[dateLabel] = 0;
        }

        prev[mode][dateLabel] += 1;
        return prev;
      },
      {
        normal: {},
        chaos: {},
      }
    );

    const normalValues = Object.keys(daily.normal).map(label => {
      return {
        label,
        value: daily.normal[label],
      };
    });

    const chaosValues = Object.keys(daily.chaos).map(label => {
      return {
        label,
        value: daily.chaos[label],
      };
    });

    return [
      {
        values: normalValues,
        key: 'Normal Game',
      },
      {
        values: chaosValues,
        key: 'Chaos Game',
      },
    ];
  };

  generateMonthlyData = () => {
    const daily = this.state.monthlyGames.reduce((prev, current) => {
      const date = moment(current.date);
      const dateLabel = date.format('D/M');
      if (!prev[dateLabel]) {
        prev[dateLabel] = 1;
      } else {
        prev[dateLabel] += 1;
      }
      return prev;
    }, {});

    const chartValue = Object.keys(daily).map(label => {
      return {
        label,
        value: daily[label],
      };
    });

    return [
      {
        values: chartValue,
        key: 'Total Game',
      },
    ];
  };

  render() {
    return (
      <div>
        <HeaderBar
          title="Adu Jempol Status"
          bodyStyle={{background: '#0081FA'}}
        />
        <div style={{padding: '.8rem'}}>
          <Grid container direction="column">
            <Grid item>
              <Grid container>
                <Grid item xs={6}>
                  <div>
                    <Paper style={{padding: '.8rem'}}>
                      <Typography type="title">Today Games</Typography>
                      <Typography type="subheading">
                        {this.state.todayGames.length}
                      </Typography>
                    </Paper>
                  </div>
                </Grid>
                <Grid item xs={6}>
                  <div>
                    <Paper style={{padding: '.8rem'}}>
                      <Typography type="title">Weekly Games</Typography>
                      <Typography type="subheading">
                        {this.state.weeklyGames.length}
                      </Typography>
                    </Paper>
                  </div>
                </Grid>
              </Grid>
            </Grid>
            <Grid item>
              <Paper style={{padding: '1rem', minHeight: '240px'}}>
                <Typography type="title" align="center">
                  Daily Total Game
                </Typography>
                <svg
                  ref="weeklyChart"
                  style={{height: '100%', width: '100%'}}
                />
                {this.weeklyChart()}
              </Paper>
            </Grid>
            <Grid item>
              <Paper style={{padding: '1rem', minHeight: '240px'}}>
                <Typography type="title" align="center">
                  Daily Total Game Mode
                </Typography>
                <svg
                  ref="gameModeChart"
                  style={{height: '100%', width: '100%'}}
                />
                {this.gameModeChart()}
              </Paper>
            </Grid>
          </Grid>
        </div>
      </div>
    );
  }
}

export default StatusPage;



// WEBPACK FOOTER //
// ./src/StatusPage.js